import { Component, Input } from '@angular/core';
import { B2bAppointmentBookingService } from './b2b-appointment-booking.service';

@Component({
  selector: 'app-b2b-appointment-booking-form',
  templateUrl: './b2b-appointment-booking-form.component.html'
})
export class B2bAppointmentBookingFormComponent {
  @Input() visible = true;

  constructor(public booking: B2bAppointmentBookingService) {}
}
